/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {
    class EditTestCaseController {
        constructor(private formService: common.FormService) {
        }
        static $inject = ['formService'];
        private testCaseId: number;
        private form;
        private formData = {
            name: "",
            description: "",
            conditions: "",
            test_data: "",
            test_suite_id: 0
        };

        private submit = ()=>{
        
            this.formService.submitForm(`/testCase/${this.testCaseId}`, 
                this.formData);
            
        }
    }

    angular.module("ultimateMonitoringApp").controller("editTestCaseController", EditTestCaseController);
}
